var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyDotRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10.711,
    height: 10.711,
    viewBox: "0 0 10.711 10.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.711,
    height: 10.711,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_25",
    "data-name": "Repeat Grid 25",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_483",
    "data-name": "Group 483",
    transform: "translate(35 -5.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_123",
    "data-name": "Group 123",
    transform: "translate(-34 6.213)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    fill: "#667284",
    stroke: "#25435f",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.355,
    cy: 4.355,
    r: 4.355,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.355,
    cy: 4.355,
    r: 3.855,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(-34 6.213)",
    fill: "none",
    stroke: "#667284",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4.355,
    cy: 4.355,
    r: 4.355,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.355,
    cy: 4.355,
    r: 4.855,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyDotRules);
export default __webpack_public_path__ + "static/media/greyDotRules.2f859ad225e13216e8e81515984cbd6b.svg";
export { ForwardRef as ReactComponent };